module.exports = __webpack_public_path__ + "img/order-note.82ea8109.svg";